<template>
  <div>
    <!-- input search -->
    <!-- <b-row v-if="$can('create','jobs')">
      <b-col cols="12" md="12">
        <div
          class=""
          style="margin-left: auto; margin-right: 0; text-align: right"
        >
          <input v-model="searchTerm"/>-->
          <!-- <router-link :to="'/apps/add-job'" >
            <b-button variant="primary">
              <span class="text-nowrap">Create Job</span>
            </b-button>
          </router-link> 
        </div>
      </b-col>
    </b-row> -->
    <!-- <b-row>
      <b-col md="2" xl="2" xs="6" class="mb-1">
        <b-form-group
          label="Client"
          label-for="client">
          <v-select
            v-model="clientSelected"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            placeholder="Select Client"
            :options="clientsOptions"
            :reduce="(option) => option.title"
          />
        </b-form-group>
      </b-col>
      <b-col md="2" xl="2" xs="6" class="mb-1">
        <b-form-group
          label="Domain"
          label-for="domain">
          <v-select
            v-model="domainSelected"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="domainsOptions"
            placeholder="Select Domain"
            ref="domain"
            :reduce="(option) => option.title"
          />
        </b-form-group>
      </b-col>
      <b-col md="2" xl="2" xs="6" class="mb-1">
        <b-form-group
          label="Account Manager"
          label-for="acc-manager">
          <v-select
            v-model="mgrSelected"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="mgrOptions"
            placeholder="Select Account Manager"
            ref="accMgr"
            :reduce="(option) => option.title"
          />
        </b-form-group>
      </b-col>
      <b-col md="2" xl="2" xs="6" class="mb-1">
        <b-form-group
          label="Location"
          label-for="location">
          <v-select
            v-model="citySelected"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            placeholder="Select Location"
            :options="citiesOptions"
            ref="city"
            :reduce="(option) => option.title"
          />
        </b-form-group>
      </b-col>
      <b-col md="2" xl="2" xs="6" class="mb-1">
        <b-form-group
          label="Search other fields"
          label-for="search-query">
          <b-form-input
            v-model="query"
            placeholder="Search by position name, recruiter, poc and many more ..."
            type="text"
            ref="skill"
            trim
          />
        </b-form-group>
      </b-col>
      <b-col md="2" xl="2" xs="6" class="mb-1">
        <b-form-group
          label=""
          label-for="">
          <b-button variant="outline-primary" value="submit" id="submit" type="submit" width="100%" @click="getFilteredJobs" style="margin-top: 20px">Filter Jobs</b-button>
        
          
        </b-form-group>
        <a @click="clearFilter">Clear Filter</a>  
      </b-col>
    </b-row> -->
    <b-row >
      
      <b-col md="2" xl="2" xs="6" class="mb-1" v-if="showFilter">
        <b-form-group
          label="Client"
          label-for="client">
          <v-select
            v-model="clientSelected"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            placeholder="Select Client"
            :options="clientsOptions"
            :reduce="(option) => option.title"
          />
        </b-form-group>
      </b-col>
      <b-col md="2" xl="2" xs="6" class="mb-1" v-if="showFilter">
        <b-form-group
          label="Domain"
          label-for="domain">
          <v-select
            v-model="domainSelected"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="domainsOptions"
            placeholder="Select Domain"
            ref="domain"
            :reduce="(option) => option.title"
          />
        </b-form-group>
      </b-col>
      <b-col md="2" xl="2" xs="6" class="mb-1" v-if="showFilter">
        <b-form-group
          label="Account Manager"
          label-for="acc-manager">
          <v-select
            v-model="mgrSelected"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="mgrOptions"
            placeholder="Select Account Manager"
            ref="accMgr"
            :reduce="(option) => option.title"
          />
        </b-form-group>
      </b-col>
      <b-col md="2" xl="2" xs="6" class="mb-1" v-if="showFilter">
        <b-form-group
          label="Location"
          label-for="location">
          <v-select
            v-model="citySelected"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            placeholder="Select Location"
            :options="citiesOptions"
            ref="city"
            :reduce="(option) => option.title"
          />
        </b-form-group>
      </b-col>
      <b-col md="2" xl="2" xs="6" class="mb-1" v-if="showFilter">
        <b-form-group
          label="Category"
          label-for="category">
          <v-select
            v-model="categorySelected"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            placeholder="Select Category"
            :options="categoryOptions"
            :reduce="(option) => option.title"
          />
        </b-form-group>
      </b-col>
      <b-col md="2" xl="2" xs="6" class="mb-1" v-if="showFilter">
        <b-form-group
          label="Verticals"
          label-for="vertical">
          <v-select
            v-model="verticalSelected"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            placeholder="Select Vertical"
            :options="verticalOptions"
            :reduce="(option) => option.title"
          />
        </b-form-group>
      </b-col>
      <b-col md="2" xl="2" xs="6" class="mb-1" v-if="showFilter">
        <b-form-group
          label="Job Type"
          label-for="jobType">
          <v-select
            v-model="jobTypeSelected"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            placeholder="Select Job Type"
            :options="jobTypeOptions"
            :reduce="(option) => option.title"
          />
        </b-form-group>
      </b-col>
      <b-col md="2" xl="2" xs="6" class="mb-1" v-if="showFilter">
        <b-form-group
          label="Job Payroll"
          label-for="payroll">
          <v-select
            v-model="payrollSelected"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            placeholder="Select Payroll Type"
            :options="payrollOptions"
            :reduce="(option) => option.title"
          />
        </b-form-group>
      </b-col>
      <b-col md="6" xl="6" xs="0" class="mt-2" v-if="!showFilter">
        <span @click="showFilters" class="mr-2 text-primary font-weight-bolder" >  <feather-icon
            icon="FilterIcon"
            size="16"
          /> More Filters
        </span>
      </b-col>
      <b-col md="2" xl="2" xs="0" class="mt-2" v-if="showFilter">
        <span @click="showFilters" class="mr-2 text-primary font-weight-bolder" >  <feather-icon
            icon="FilterIcon"
            size="16"
          /> Hide Filters
        </span>
      </b-col>
      
      <b-col md="4" xl="4" xs="6" class="mb-1" v-if="!showFilter">
        <b-form-group
          label="Search other fields"
          label-for="search-query">
          <b-form-input
            v-model="query"
            placeholder="Search by position name, client, desired skills, recruiter, poc and many more ..."
            type="text"
            ref="skill"
            trim
          />
        </b-form-group>
      </b-col>
      <b-col md="4" xl="4" xs="6" class="mb-1" v-if="showFilter">
        <b-form-group
          label="Search other fields"
          label-for="search-query">
          <b-form-input
            v-model="query"
            placeholder="Search by position name, client, desired skills, recruiter, poc and many more ..."
            type="text"
            ref="skill"
            trim
          />
        </b-form-group>
      </b-col>
      <b-col md="2" xl="2" xs="6" class="mb-1">
          <b-button variant="outline-primary" value="submit" id="submit" type="submit" width="100%" @click="getFilteredJobs" style="margin-top: 20px">Filter Jobs</b-button>
         
          <a @click="clearFilter">Clear Filter</a>
          <!-- <b-button class="mr-2" variant="outline-info" @click="showFilterOptions">
            <feather-icon
                icon="FilterIcon"
                size="18"
            /> more filters
          </b-button>
          {{ showFilters }} -->
      </b-col>
      <!-- <b-col md="2" xl="2" xs="6" class="mt-2">
        
      </b-col> -->
    </b-row>
    
    <div v-if="loading">
      <div class="text-center">
        <b-spinner variant="primary" label="Text Centered" />
      </div>
    </div>
    <div v-if="jobData.length > 0"  id="scrolldata"  >
      <b-card
        v-for="job in jobData"
        :key="job.job_id"
        no-body
        class="card-browser-states mt-50"
      >
        <b-card-header>
          
            <h4 class="mb-0 ml-1">{{ job.position_name }}
            <span class="card-text" v-if="job.role">| {{ job.role }}</span>
            <span class="card-text" v-if="job.band && job.band !== 'undefined'">| {{ job.band }}</span>
          </h4>
          <b-col md="6" xl="6" xs="6">
            <div>
              <div class="demo-inline-spacing text-danger" v-if="job.initiated == 0 && job.profileshared == 0 && job.shortlisted == 0 && job.offered == 0 && job.joined == 0 && job.inprocess == 0">
                No Candidates Added for the Job Yet!!!
              </div>
              <div class="demo-inline-spacing" v-else>
                <b-avatar
                  v-b-tooltip.hover
                  :text="job.initiated"
                  variant="light-secondary"
                  badge="I"
                  title="Initiated"
                />
                <b-avatar
                  v-b-tooltip.hover
                  :text="job.profileshared"
                  variant="light-info"
                  badge="P"
                  title="Profile-Shared"
                />
                <b-avatar
                  v-b-tooltip.hover
                  :text="job.inprocess"
                  variant="light-success"
                  badge="I"
                  title="Inprocess"
                />
                <b-avatar
                  v-b-tooltip.hover
                  :text="job.shortlisted"
                  variant="light-primary"
                  badge="S"
                  title="Shortlisted"
                />
                <b-avatar
                  v-b-tooltip.hover
                  :text="job.offered"
                  variant="light-primary"
                  badge="O"
                  title="Offered"
                />
                <b-avatar
                  v-b-tooltip.hover
                  :text="job.joined"
                  variant="light-primary"
                  badge="J"
                  title="Joined"
                />
              </div>
              
            </div>
          </b-col>
        </b-card-header>

        <!-- body -->
        <b-card-body style="padding: 1rem !important">
          <router-link
            :to="{ name: 'apps-view-job', params: { id: job.id } }"
          >
            <b-row style="color: #5e5873 !important; font-size: 0.9rem">
              <b-col md="3" xl="3" xs="6" sm="6">
                <div class="mb-1">
                  <h4 class="mb-0">
                    <span>{{ job.client }}</span>
                    |
                    <span>{{ job.domain }}</span
                    >
                  </h4>
                  <span class="card-text">{{ job.status }}</span> |
                  <span class="card-text">{{ job.type }}</span> | 
                  <span class="card-text"> Added on {{ job.createdAt }}</span>
                  <!--<span class="card-text"> {{ job.id }}</span>-->
                  <p>
                    <span class="card-text">{{ job.locations }}</span> | 
                    <span class="card-text">{{ job.job_id }}</span>
                  </p>
                </div>
              </b-col>

              <b-col md="2" xl="2" xs="6" sm="6">
                <div class="mb-1">
                  <h6 class="mb-0">Positions : {{ job.no_of_vacancies }}</h6>
                  <span class="card-text" v-if="job.opened && job.closed">Open: {{job.opened}} | Closed: {{job.closed}}</span>
                  <span class="card-text" v-else>Open: {{job.no_of_vacancies}} | Closed: 0</span>
                </div>
              </b-col>
              <b-col md="2" xl="2" xs="6" sm="6">
                <div class="mb-1">
                  <b-avatar-group size="32px">
                    <b-avatar
                      v-for="(recruit, index) in job.recruiters"
                      :key="'B' + index"
                      v-b-tooltip.hover
                      class="pull-up"
                      :title="recruit.title"
                      variant="light-primary"
                      :text="avatarText(recruit.title)"
                    />
                  </b-avatar-group>
                </div>
              </b-col>
              <b-col md="2" xl="2" xs="6" sm="6">
                <div>
                  <h6 class="mb-0">
                    {{ job.account_mgr }}
                  </h6>
                  <b-avatar-group size="32px" v-if="job.sourcer">
                    <b-avatar
                      v-for="(source, index) in job.sourcer"
                      :key="'C' + index"
                      v-b-tooltip.hover
                      class="pull-up"
                      :title="source.title"
                      variant="light-primary"
                      :text="avatarText(source.title)"
                    />
                  </b-avatar-group>
                </div>
              </b-col>
              <b-col md="2" xl="2" xs="6" sm="6">
                
                  <h6 class="mb-0">
                    {{ job.poc }}
                  </h6>
                
              </b-col>
              
              <div
                style="margin-left: auto; margin-right: 0; text-align: right; padding-right: 10px;"
              >
                <router-link :to="'/apps/edit-job/' + job.id" v-if="$can('update','jobs')">
                  <feather-icon icon="EditIcon" size="18" class="mr-50" />
                </router-link>
                <b-dropdown v-if="$can('update','job_status') || $can('create','job_notes')"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                  right
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item v-if="$can('update','job_status')" @click="showModal(job.id, job.job_id, job.status)">
                    <feather-icon icon="Edit2Icon" class="mr-50" />
                    <span>Update Status</span>
                  </b-dropdown-item>
                  <b-dropdown-item v-if="$can('create','job_notes')" @click="showModalNotes(job.id, job.job_id)">
                    <feather-icon icon="ClipboardIcon" class="mr-50" />
                    <span>Add Notes</span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </b-row>
          </router-link>
        </b-card-body>
      </b-card>
    </div>
    <div v-if="totalCount > 0" class="text-center">
      <BButton variant="primary" @click="loadMore()" >Load More ..</BButton>
    </div>
    <div v-else class="text-center">
      All Jobs Loaded !!!
    </div>

    <div v-if="filteredData.length < 1 && !loading">
      <b-card>
        <h5>
        No Jobs Assigned to you yet !!! <br>Contact your Team Lead to assign jobs to you.</h5>
      </b-card>
    </div>
    <b-modal
      id="modal-update-status"
      ref="modal-update-status"
      title="Update Status"
      ok-title="submit"
      cancel-variant="outline-secondary"
      @ok="updateStatus"
    >
      <b-form>
        <b-form-group label="Choose the status" label-for="vue-select">
          <li style="display: inline-flex; margin: 5px; padding: 2px" v-for="status in statusOption" :key="status.text">
            <b-badge style="color: black !important;" variant="light" :id="status.text" @click="selectStatus(status.text)">{{ status.value }}</b-badge>
          </li>
        </b-form-group>
      </b-form>
    </b-modal>
    <b-modal
      id="modal-add-notes"
      ref="modal-add-notes"
      title="Add Notes"
      ok-title="submit"
      cancel-variant="outline-secondary"
      @ok="updateNotes"
    >
      <b-form>
        <b-form-group label="Add Notes" label-for="vue-select">
          <b-form-textarea
            id="textarea-default"
            v-model="notes"
            placeholder="Add Notes"
            rows="3"
          />
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
// import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BButton,
  BAvatarGroup,
  BAvatar,
  VBTooltip,
  BCard,
  BRow,
  BCol,
  BCardBody,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormGroup,
  BFormTextarea,
  BCardHeader,
  BBadge,
  BListGroupItem,
  BSpinner,
  BFormInput,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
// import { VueGoodTable } from 'vue-good-table'
import useJwt from "@/auth/jwt/useJwt";
import JobService from "@/services/job-service";
import NoteService from "@/services/note-service";
import store from "@/store/index";
import Ripple from "vue-ripple-directive";
import moment from "moment";

import jobTimelineService from '@/services/job-timeline'
import clientService from '@/services/client-service'
import domainService from '@/services/domain-service'
import UserService from '@/services/user-service'
import locationService from "@/services/location-service";
import adminConfigService from '@/services/admin-config-service'
import {
  resolveJobScopeUser,
  buildFilteredJobList,
  buildCandidatePipeline,
  jobListScrollRestoreMixin,
} from './job-list-helpers'
// import { codeColumnSearch } from './code'

export default {
  mixins: [jobListScrollRestoreMixin],
  components: {
    // VueGoodTable,
    BAvatar,
    BCardBody,
    BCard,
    BButton,
    BAvatarGroup,
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
    BFormGroup,
    BForm,
    vSelect,
    BFormTextarea,
    BCardHeader,
    ToastificationContent,
    BBadge,
    BListGroupItem,
    BSpinner,
    BFormInput,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  props: {
    /*jobData: {
      type: Object,
      required: true,
    },*/
  },
  data() {
    return {
      dir: false,
      //recruiter: [ { "title": "Aakanksha Pandey", "emp_id": "SH-016" }, { "title": "Nikita Tiwari", "emp_id": "SH-006" } ],
      recruiters: [],
      // codeColumnSearch,
      role: '',
      id: '',
      prevStatus: '',
      jobData: [],
      originalData: [],
      fetchCandidates: [],
      totalCandidates: 0,
      initiatedC: 0,
      approvedC: 0,
      inprocessC: 0,
      shortlistedC: 0,
      offeredC: 0,
      joinedC: 0,
      cStatus: {},
      clientsOptions: [],
      domainsOptions: [],
      mgrOptions: [],
      citiesOptions: [{"title":"Mumbai"},{"title":"Delhi"},{"title":"Bangalore"},{"title":"Hyderabad"},{"title":"Pune"},{"title":"Ahmedabad"},{"title":"Chennai"},{"title":"Kolkata"},{"title":"Surat"},{"title":"Jaipur"},{"title":"Lucknow"},{"title":"Kanpur"},{"title":"Nagpur"},{"title":"Indore"},{"title":"Thane"},{"title":"Bhopal"},{"title":"Visakhapatnam"},{"title":"Pimpri and Chinchwad"},{"title":"Patna"},{"title":"Vadodara"},{"title":"Ghaziabad"},{"title":"Ludhiana"},{"title":"Agra"},{"title":"Nashik"},{"title":"Faridabad"},{"title":"Meerut"},{"title":"Rajkot"},{"title":"Kalyan and Dombivali"},{"title":"Vasai Virar"},{"title":"Varanasi"},{"title":"Srinagar"},{"title":"Aurangabad"},{"title":"Dhanbad"},{"title":"Amritsar"},{"title":"Navi Mumbai"},{"title":"Allahabad"},{"title":"Haora"},{"title":"Ranchi"},{"title":"Gwalior"},{"title":"Jabalpur"},{"title":"Coimbatore"},{"title":"Vijayawada"},{"title":"Jodhpur"},{"title":"Madurai"},{"title":"Raipur"},{"title":"Kota"},{"title":"Chandigarh"},{"title":"Guwahati"},{"title":"Solapur"},{"title":"Hubli and Dharwad"},{"title":"Bareilly"},{"title":"Mysore"},{"title":"Moradabad"},{"title":"Gurgaon"},{"title":"Aligarh"},{"title":"Jalandhar"},{"title":"Tiruchirappalli"},{"title":"Bhubaneswar"},{"title":"Salem"},{"title":"Mira and Bhayander"},{"title":"Thiruvananthapuram"},{"title":"Bhiwandi"},{"title":"Saharanpur"},{"title":"Gorakhpur"},{"title":"Guntur"},{"title":"Amravati"},{"title":"Bikaner"},{"title":"Noida"},{"title":"Jamshedpur"},{"title":"Bhilai Nagar"},{"title":"Warangal"},{"title":"Cuttack"},{"title":"Firozabad"},{"title":"Kochi"},{"title":"Bhavnagar"},{"title":"Dehradun"},{"title":"Durgapur"},{"title":"Asansol"},{"title":"Nanded Waghala"},{"title":"Kolapur"},{"title":"Ajmer"},{"title":"Gulbarga"},{"title":"Loni"},{"title":"Ujjain"},{"title":"Siliguri"},{"title":"Ulhasnagar"},{"title":"Jhansi"},{"title":"Sangli Miraj Kupwad"},{"title":"Jammu"},{"title":"Nellore"},{"title":"Mangalore"},{"title":"Belgaum"},{"title":"Jamnagar"},{"title":"Tirunelveli"},{"title":"Malegaon"},{"title":"Gaya"},{"title":"Ambattur"},{"title":"Jalgaon"},{"title":"Udaipur"},{"title":"Maheshtala"},{"title":"Tiruppur"},{"title":"Davanagere"},{"title":"Kozhikode"},{"title":"Kurnool"},{"title":"Akola"},{"title":"Rajpur Sonarpur"},{"title":"Bokaro Steel"},{"title":"Bellary"},{"title":"Patiala"},{"title":"South Dum Dum"},{"title":"Rajarhat Gopalpur"},{"title":"Bhagalpur"},{"title":"Agartala"},{"title":"Muzaffarnagar"},{"title":"Bhatpara"},{"title":"Latur"},{"title":"Panihati"},{"title":"Dhule"},{"title":"Rohtak"},{"title":"Korba"},{"title":"Bhilwara"},{"title":"Brahmapur Town"},{"title":"Muzaffarpur"},{"title":"Ahmadnagar"},{"title":"Mathura"},{"title":"Kollam"},{"title":"Avadi"},{"title":"Kadapa"},{"title":"Rajahmundry"},{"title":"Bilaspur"},{"title":"Kamarhati"},{"title":"Shahjahanpur"},{"title":"Bijapur"},{"title":"Rampur"},{"title":"Shimoga"},{"title":"Chandrapur"},{"title":"Junagadh"},{"title":"Thrissur"},{"title":"Alwar"},{"title":"Barddhaman"},{"title":"Kulti"},{"title":"Kakinada"},{"title":"Nizamabad"},{"title":"Parbhani"},{"title":"Tumkur"},{"title":"Hisar"},{"title":"Ozhukarai"},{"title":"Biharsharif"},{"title":"Darbhanga"},{"title":"Panipat"},{"title":"Aizawl"},{"title":"Bally"},{"title":"Dewas"},{"title":"Tirupati"},{"title":"Ichalkaranji"},{"title":"Karnal"},{"title":"Bathinda"},{"title":"Jalna"},{"title":"Kirari Suleman Nagar"},{"title":"Purnia"},{"title":"Satna"},{"title":"Maunath Bhanjan"},{"title":"Barasat"},{"title":"Sonipat"},{"title":"Farrukhabad and Fatehgarh"},{"title":"Sagar"},{"title":"Raurkela"},{"title":"Durg"},{"title":"Imphal"},{"title":"Ratlam"},{"title":"Hapur"},{"title":"Arrah"},{"title":"Karimnagar"},{"title":"Anantapur"},{"title":"NDMC"},{"title":"Etawah"},{"title":"Ambernath"},{"title":"Bharatpur"},{"title":"Begusarai"},{"title":"Tiruvottiyur"},{"title":"North Dum Dum"},{"title":"Gandhidham"},{"title":"Baranagar"},{"title":"Puducherry"},{"title":"Thoothukkudi"},{"title":"Sikar"},{"title":"Rewa"},{"title":"Mirzapur and Vindhyachal"},{"title":"Raichur"},{"title":"Pali"},{"title":"Ramagundam"},{"title":"Hardwar"},{"title":"Vizianagaram"},{"title":"Katihar"},{"title":"Nagercoil"},{"title":"Ganganagar"},{"title":"Karawal Nagar"},{"title":"Mango"},{"title":"Thanjavur"},{"title":"Bulandshahr"},{"title":"Uluberia"},{"title":"Murwara"},{"title":"Sambhal"},{"title":"Singrauli"},{"title":"Nadiad"},{"title":"Secunderabad"},{"title":"Naihati"},{"title":"Yamunanagar"},{"title":"Bidhan Nagar"},{"title":"Pallavaram"},{"title":"Bidar"},{"title":"Munger"},{"title":"Panchkula"},{"title":"Burhanpur"},{"title":"Raurkela Industrial Township"},{"title":"Kharagpur"},{"title":"Dindigul"},{"title":"Hospet"},{"title":"Gandhinagar"},{"title":"Nangloi Jat"},{"title":"English Bazar"},{"title":"Ongole"},{"title":"Eluru"},{"title":"Deoghar"},{"title":"Chapra"},{"title":"Haldia"},{"title":"Khandwa"},{"title":"Puri Town"},{"title":"Nandyal"},{"title":"Morena"},{"title":"Amroha"},{"title":"Anand"},{"title":"Bhind"},{"title":"Bhalswa Jahangir Pur"},{"title":"Madhyamgram"},{"title":"Bhiwani"},{"title":"Navi Mumbai Panvel Raigad"},{"title":"Baharampur"},{"title":"Ambala"},{"title":"Morvi"},{"title":"Fatehpur"},{"title":"Rae Bareli"},{"title":"Khora"},{"title":"Bhusawal"},{"title":"Orai"},{"title":"Bahraich"},{"title":"Vellore"},{"title":"Mahesana"},{"title":"Khammam"},{"title":"Sambalpur"},{"title":"Raiganj"},{"title":"Sirsa"},{"title":"Dinapur Nizamat"},{"title":"Serampore"},{"title":"Sultan Pur Majra"},{"title":"Guna"},{"title":"Jaunpur"},{"title":"Panvel"},{"title":"Shivpuri"},{"title":"Surendranagar Dudhrej"},{"title":"Unnao"},{"title":"Hugli and Chinsurah"},{"title":"Sitapur"},{"title":"Hastsal"},{"title":"Tambaram"},{"title":"Adityapur"},{"title":"Badalapur"},{"title":"Alappuzha"},{"title":"Cuddalore"},{"title":"Silchar"},{"title":"Gadag and Betigeri"},{"title":"Bahadurgarh"},{"title":"Machilipatnam"},{"title":"Shimla"},{"title":"Medinipur"},{"title":"Deoli"},{"title":"Bharuch"},{"title":"Hoshiarpur"},{"title":"Jind"},{"title":"Chandannagar"},{"title":"Adoni"},{"title":"Tonk"},{"title":"Faizabad"},{"title":"Tenali"},{"title":"Alandur"},{"title":"Kancheepuram"},{"title":"Vapi"},{"title":"Rajnandgaon"},{"title":"Proddatur"},{"title":"Navsari"},{"title":"Budaun"},{"title":"Uttarpara Kotrung"},{"title":"Mahbubnagar"},{"title":"Erode"},{"title":"Batala"},
      {"title":"Saharsa"},{"title":"Haldwani and Kathgodam"},{"title":"Vidisha"},{"title":"Thanesar"},{"title":"Kishangarh"},{"title":"Dallo Pura"},{"title":"Veraval"},{"title":"Banda"},{"title":"Chittoor"},{"title":"Krishnanagar"},{"title":"Barrackpur"},{"title":"Lakhimpur"},{"title":"Santipur"},{"title":"Porbandar"},{"title":"Hindupur"},{"title":"Balurghat"},{"title":"Bhadravati"},{"title":"Hanumangarh"},{"title":"Moga"},{"title":"Pathankot"},{"title":"Hajipur"},{"title":"Sasaram"},{"title":"Habra"},{"title":"Bid"},{"title":"Mohali"},{"title":"Burari"},{"title":"Beawar"},{"title":"Abohar"},{"title":"Tiruvannamalai"},{"title":"Jamuria"},{"title":"Kaithal"},{"title":"Godhra"},{"title":"Bhuj"},{"title":"Robertson Pet"},{"title":"Shillong"},{"title":"Rewari"},{"title":"Hazaribag"},{"title":"Bhimavaram"},{"title":"Mandsaur"},{"title":"Chas"},{"title":"Rudrapur"},{"title":"Chitradurga"},{"title":"Kumbakonam"},{"title":"Dibrugarh"},{"title":"Kolar"},{"title":"Chhindwara"},{"title":"Bankura"},{"title":"Mandya"},{"title":"Dehri"},{"title":"Raigarh"},{"title":"Madanapalle"},{"title":"Nalgonda"},{"title":"Hathras"},{"title":"Malerkotla"},{"title":"Siwan"},{"title":"Chhattarpur"},{"title":"Hassan"},{"title":"Lalitpur"},{"title":"Gondiya"},{"title":"North Barrackpur"},{"title":"Bettiah"},{"title":"Palakkad"},{"title":"Rajapalayam"},{"title":"Botad"},{"title":"Modinagar"},{"title":"Deoria"},{"title":"Raniganj"},{"title":"Palwal"},{"title":"Khanna"},{"title":"Neemuch"},{"title":"Pilibhit"},{"title":"Mustafabad"},{"title":"Hardoi"},{"title":"Guntakal"},{"title":"Pithampur"},{"title":"Motihari"},{"title":"Dhaulpur"},{"title":"Srikakulam"},{"title":"Nabadwip"},{"title":"Patan"},{"title":"Jagdalpur"},{"title":"Udupi"},{"title":"Basirhat"},{"title":"Damoh"},{"title":"Halisahar"},{"title":"Jagadhri"},{"title":"Rishra"},{"title":"Kurichi"},{"title":"Dimapur"},{"title":"Palanpur"},{"title":"Dharmavaram"},{"title":"Gokal Pur"},{"title":"Kashipur"},{"title":"Ashokenagar Kalyangarh"},{"title":"Baidyabati"},{"title":"Sawai Madhopur"},{"title":"Puruliya"},{"title":"Mandoli"},{"title":"Mainpuri"},{"title":"Kanchrapara"},{"title":"Satara"},{"title":"Churu"},{"title":"Madavaram"},{"title":"Gangapur"},{"title":"Dabgram"},{"title":"Darjiling"},{"title":"Barshi"},{"title":"Etah"},{"title":"Jhunjhunun"},{"title":"Chikmagalur"},{"title":"Jetpur Navagadh"},{"title":"Roorkee"},{"title":"Gudivada"},{"title":"Baleshwar"},{"title":"Baran"},{"title":"Hoshangabad"},{"title":"Nagaon"},{"title":"Pudukkottai"},{"title":"Adilabad"},{"title":"Hosur"},{"title":"Muktsar"},{"title":"Yavatmal"},{"title":"Titagarh"},{"title":"Barnala"},{"title":"Chittaurgarh"},{"title":"Narasaraopet"},{"title":"Dum Dum"},{"title":"Basti"},{"title":"Valsad"},{"title":"Ambur"},{"title":"Giridih"},{"title":"Chandausi"},{"title":"Gonda"},{"title":"Bally Town"},{"title":"Kalol"},{"title":"Bagaha"},{"title":"Ambikapur"},{"title":"Achalpur"},{"title":"Gondal"},{"title":"Bagalkot"},{"title":"Osmanabad"},{"title":"Akbarpur"},{"title":"Champdani"},{"title":"Deesa"},{"title":"Khurja"},{"title":"Nandurbar"},{"title":"Azamgarh"},{"title":"Ghazipur"},{"title":"Delhi Cantonment"},{"title":"Firozpur"},{"title":"Baripada"},{"title":"Mughalsarai"},{"title":"Anantnag"},{"title":"Sehore"},{"title":"Bongaon"},{"title":"Kanpur Cantonment"},{"title":"Khardaha"},{"title":"Tadpatri"},{"title":"Port Blair"},{"title":"Sultanpur"},{"title":"Bhadrak"},{"title":"Shikohabad"},{"title":"Jalpaiguri"},{"title":"Shamli"},{"title":"Karaikkudi"},{"title":"Khargone"},{"title":"Wardha"},{"title":"Ranibennur"},{"title":"Kishanganj"},{"title":"Neyveli"},{"title":"Amreli"},{"title":"Suryapet"},{"title":"Gangawati"},{"title":"Hindaun"},{"title":"Jamalpur"},{"title":"Bhiwadi"},{"title":"Ballia"},{"title":"Bansberia"},{"title":"Tadepalligudem"},{"title":"Miryalaguda"},{"title":"Baraut"},{"title":"Udgir"},{"title":"Betul"},{"title":"Bundi"},{"title":"Jehanabad"},{"title":"Ambala Sadar"},{"title":"Nagapattinam"},{"title":"Nagaur"},{"title":"Buxar"},{"title":"Seoni"},{"title":"Greater Noida"},{"title":"Hinganghat"},{"title":"Sujangarh"},{"title":"Bhadreswar"},{"title":"Chilakaluripet"},{"title":"Kasganj"},{"title":"Kalyani"},{"title":"Gangtok"},{"title":"Datia"},{"title":"Nagda"},{"title":"Banswara"},{"title":"Kapurthala"}, {"title": "Remote"}, {"title": "PAN INDIA"}, {"title": "Ratnagiri"}, {"title": "Goa"}, {"title": "Panaji"}],
      searchTerm: "",
      avatarText,
      statusSelected: "",
      job_id: "",
      statusOption: [
        { value: 'Active', text: 'Active' },
        { value: 'On Hold', text: 'OnHold' },
        { value: 'Draft', text: 'Draft' },
        { value: 'Closed', text: 'Closed' },
        { value: 'Cancelled', text: 'Cancelled' },
        { value: 'Target Date Breached', text: 'TargetDateBreached' },
      ],
      notes: "",
      citySelected: '',
      domainSelected: '',
      clientSelected: '',
      mgrSelected: '',
      query: '',
      loading: true,
      wholeData: [],
      totalCount: 0,
      page: 1,
      size: 30,
      user: '',
      userRole: '',
      scrollHeight: 0,
      showFilter: false,
      categoryOptions: [],
      verticalOptions: [],
      payrollOptions: [],
      jobTypeOptions: [],
      jobStatusOptions: [],

      //recruiters: [],
      //accountMgr: []
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Closed: "light-success",
        Cancelled: "light-danger",
        OnHold: "light-warning",
        TargetDateBreached: "light-warning",
        Draft: "light-secondary",
        Active: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    // ifPermitted() {
    //   const userD = JSON.parse(localStorage.getItem('userData'))
    //   const role = userD.roles[0]
    //   let permit = false
    //   if(role === 'ACCOUNT-MANAGER' || role === 'ADMIN' || role === 'MASTER' ){
    //     permit = true
    //   } else {
    //     permit = false
    //   }
    //   return permit;
    // },
    // ifHRMIS() {
    //   const userD = JSON.parse(localStorage.getItem('userData'))
    //   const role = userD.roles[0]
    //   let permit = false
    //   if( role === 'HR' || role === 'MIS' ){
    //     permit = false
    //   } else {
    //     permit = true
    //   }
    //   return permit;
    // },
    direction() {
      return store.state.appConfig.isRTL
    },
    filteredData() {
      return buildFilteredJobList(this.jobData, {
        clientSelected: this.clientSelected,
        domainSelected: this.domainSelected,
        citySelected: this.citySelected,
        mgrSelected: this.mgrSelected,
      })
    },

    
  },
  
  created() {
    this.user = JSON.parse(localStorage.getItem('emp_id'))
    this.userRole = JSON.parse(localStorage.getItem('userData')).roles[0]
    this.getJobData();

    clientService.getClients().then(res => {
      this.clientsOptions = res.data
      //console.log(this.clientsOptions)
    })
    domainService.getDomains().then(res => {
      this.domainsOptions = res.data
      //console.log(this.domainsOptions)
    })
    locationService.getAll().then(res => {
      this.citiesOptions = res.data
    })
    UserService.getAllManagersList().then(res => {
      this.mgrOptions = res.data//.filter(item => item.status === 'ACTIVE')
    })
    
  },
  methods: {
    getJobData() {
      this.user = resolveJobScopeUser(this)
        JobService.getActiveJobs(this.user, this.size, 1, 'Closed').then((res) => {
          if (res.status === "OK") {
            this.totalCount = parseInt(res.count)
            this.jobData = res.data
            this.loading = false
          } else if ((res.status === 401 )) {
            window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
          }
        }).catch(() => {
          this.loading = false
        });
    },
    loadMore() {
      
      if(this.totalCount > 0 ) {
  
      this.loading = true
      this.totalCount = this.totalCount - this.size
      this.page = this.page + 1
      this.user = resolveJobScopeUser(this)
        JobService.getActiveJobs(this.user, this.size, this.page, 'Closed').then((res) => {
          
          if (res.status === "OK") {
            
            for(let i=0; i < res.data.length; i++) {
              this.jobData.push(res.data[i])
            }
            
            this.loading = false
          } else if (
            res.status === 401 &&
            res.data.error.message === "jwt expired"
          ) {
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
          }
        }).catch(() => {
          this.loading = false
        });
      }
    },
    getFilteredJobs() {
      this.user = resolveJobScopeUser(this)
        //this.$router.push({ path: '/apps/jobs', query: { client: this.clientSelected, domain: this.domainSelected, location: this.citySelected, mgr: this.mgrSelected, query: this.query }});

        //console.log('selected filter for jobs',this.clientSelected, this.domainSelected, this.citySelected, this.mgrSelected, this.query)

        this.clientSelected = this.clientSelected == null || this.clientSelected == undefined ? '' : this.clientSelected
        this.domainSelected = this.domainSelected == null || this.domainSelected == undefined ? '' : this.domainSelected
        this.citySelected = this.citySelected == null || this.citySelected == undefined ? '' : this.citySelected
        this.mgrSelected = this.mgrSelected == null || this.mgrSelected == undefined ? '' : this.mgrSelected

        this.categorySelected = this.categorySelected == null || this.categorySelected == undefined ? '' : this.categorySelected
        this.verticalSelected = this.verticalSelected == null || this.verticalSelected == undefined ? '' : this.verticalSelected
        this.jobTypeSelected = this.jobTypeSelected == null || this.jobTypeSelected == undefined ? '' : this.jobTypeSelected
        this.payrollSelected = this.payrollSelected == null || this.payrollSelected == undefined ? '' : this.payrollSelected
        this.query = this.query == null || this.query == undefined ? '' : this.query.toLowerCase()
        JobService.getFilteredJobs(this.user, this.clientSelected, this.domainSelected, this.citySelected, this.mgrSelected, this.categorySelected, this.verticalSelected, this.jobTypeSelected, this.payrollSelected,this.query, 'Closed').then( res => {
          if (res.status === "OK") {
            this.jobData = res.data
          } else if ((res.status === 401 ) || (res.status === 403 )) {
            window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
          }
        })
      
    },
    clearFilter() {
      this.getJobData();
      this.mgrSelected = ''
      this.domainSelected = ''
      this.clientSelected = ''
      this.citySelected = ''
      this.categorySelected = ''
      this.verticalSelected = ''
      this.jobTypeSelected = ''
      this.payrollSelected = ''
      this.query = ''
    },
   
    /*filterData() {
      var filteredData = [];
      ////console.log(this.citySelected, typeof this.citySelected);
      if (
        this.citySelected.title !== "All Cities" ||
        this.clientSelected.title !== "All Clients" ||
        this.domainSelected.title !== "All Domains" ||
        this.mgrSelected.title !== "All Managers"
      ) {
        ////console.log(this.jobData);
        filteredData = this.jobData.filter((item) => {
          item.client[0].title == this.clientSelected.title;
        });
        ////console.log(filteredData);
        this.jobData = filteredData;
      } else {
        this.jobData = this.originalData;
      }
    },*/
    candidatePipeline(candidates, o) {
      return buildCandidatePipeline(candidates, o)
    },
    showModal(id, jobid, status) {
      this.job_id = jobid;
      this.prevStatus = status;
      this.id = id
      ////console.log(this.statusSelected)

      this.$refs["modal-update-status"].show();
    },
    showModalNotes(id, job_id) {
      this.id = id;
      this.job_id = job_id
      ////console.log(this.job_id)
      this.$refs["modal-add-notes"].show();
    },
    selectStatus(status) {
      this.statusSelected = status
      

      for (var i = 0; i < this.statusOption.length; i++) {
        if (this.statusOption[i].text === status) {
          document.getElementById(this.statusOption[i].text).classList.remove('badge-light')
          document.getElementById(this.statusOption[i].text).classList.add('badge-primary')
          var el = document.getElementById(status);
          el.style.color = 'white';
        } else {
          document.getElementById(this.statusOption[i].text).classList.remove('badge-primary')
          document.getElementById(this.statusOption[i].text).classList.add('badge-light')
          var el = document.getElementById(this.statusOption[i].text);
          el.style.color = 'black';
        }
      }
    },
    updateStatus() {
      ////console.log(this.statusSelected.value)
      const userData = JSON.parse(localStorage.getItem('userData'));

        const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`
        //console.log("this.user", this.user)
        const username= `${userData.first_name} ${userData.last_name}`
      const status = {
        status: this.statusSelected,
        updated_by: user
      };
      JobService.updateJobStatus(this.job_id, status).then((res) => {
        ////console.log(res.data)
        if (res.status === "OK") {
          const timelineData = {
            title: `${this.job_id} - Job Status Updated to  - ${status}`,
            description: `Previous Status: ${this.prevStatus}`,
            type: "info",
            createdBy: username,
            jobId: this.id,
            candidate_id: null
          }
          
          jobTimelineService.create(timelineData).then(() => {})
          this.getJobData();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Job Status Updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } else if ((res.status === 401 ) || (res.status === 403 )) {
          window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
        }
        else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Job Status Update Failed",
            icon: "EditIcon",
            variant: "danger",
          },
        });
        }
      });
    },
    updateNotes() {
      ////console.log(this.statusSelected.value)
      const userData = JSON.parse(localStorage.getItem('userData'));

      const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`

      const notes = {
        note_description: this.notes,
        jobId: this.id,
        recruiter_id: user,
      };
      //console.log(notes)
      
      NoteService.addNote(notes).then((res) => {
        ////console.log(res.data)
        const userData = JSON.parse(localStorage.getItem('userData'));

        const username = `${userData.first_name} ${userData.last_name}`
        
        if(res.status === "OK") {
          const timelineData = {
            title: `${this.job_id} - Note Added to Job`,
            description: `${res.data.note_description} `,
            type: "info",
            createdBy: username,
            jobId: this.id,
            candidate_id: null
          }
          //console.log(timelineData);
          
          jobTimelineService.create(timelineData).then(() => {})
          this.getJobData();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Job Notes Added",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } else if ((res.status === 401 ) || (res.status === 403 )) {
            window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Job Note Add Failed",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      });
      this.notes = "";
    },
    showFilters() {
      this.showFilter = !this.showFilter
    },

    /* onRowClick(params) {
      this.$router.push({ name: 'apps-view-job', params: { id: params.row.id } })
    }, */
  },
  mounted() {
    adminConfigService.getJobsDropdownList().then(res=>{
        this.jobStatusOptions = res.data.data.jobStatusList
        this.jobTypeOptions = res.data.data.jobTypeList
        this.categoryOptions = res.data.data.categoryList
        this.payrollOptions = res.data.data.payrollList
        this.verticalOptions = res.data.data.verticalList
    })
    
  },
};
</script>

<style scoped>
.demo-inline-spacing > * {
  margin-top: 0.1rem !important;
}
.b-avatar {
  width: 2.5rem !important;
  height: 2.5rem !important;
  font-size: 1.05rem !important;
}
.card-header {
  padding: 0.7rem !important;
}
span.b-avatar-badge.badge-primary {
  bottom: -8px !important;
  right: -10px !important;
}
</style>
